<!-- 章节练习 -->
<template>
    <div>
      <el-row class="course_sut_Practice">
        <ul>
          <template v-for="(item, index) in dataList">
            <li :key="index">
              <span class="num_practice">{{index + 1}}</span>
              <el-row>
                <p class="title_practice limit_line_one">章节名称：{{item.teacherOpenCourseQuestionSettingName}}</p>
                <p class="number_practice">题目总数量：{{item.questionTotalCount}}题</p>
              </el-row>
              <el-row class="m20">
                <p class="grade_Practice">{{item.questionLogSummaryStudentTotalScore!=undefined&&item.questionLogSummaryStudentTotalScore!=null?item.questionLogSummaryStudentTotalScore:'-'}}<span> 分</span></p>
              </el-row>
              <el-row class="m20">
                <el-col :span="6" class="tc">
                  <el-image class="practice_img c_p" :src="dati" @click="Exercises(item)"></el-image>
                  <p class="mt10 c_p" @click="Exercises(item)">开始答题</p>
                </el-col>
                <el-col :span="6" class="tc">
                  <el-image class="practice_img c_p" :src="chengji" @click="achievement(item)"></el-image>
                  <p class="mt10 c_p" @click="achievement(item)">成绩详情</p>
                </el-col>
                <el-col :span="6" class="tc">
                  <el-image class="practice_img c_p" :src="cuoti" @click="ErrorSet(item)"></el-image>
                  <p class="mt10 c_p" @click="ErrorSet(item)">我的错题</p>
                </el-col>
                <el-col :span="6" class="tc">
                  <el-image class="practice_img c_p" :src="shouc" @click="favorites(item)"></el-image>
                  <p class="mt10 c_p" @click="favorites(item)">我的收藏</p>
                </el-col>
              </el-row>
            </li>
          </template>
        </ul>
      </el-row>
      <div v-if="dataList.length > 0"  class="block" style="text-align: right;bottom: 0;width: 96%;margin">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="page"
          :page-sizes="[9, 20, 50, 100]"
          :page-size="limit"
          background
          :hide-on-single-page="true"
          layout="sizes, prev, pager, next,jumper"
          :total="total">
        </el-pagination>
      </div>
      <el-empty v-if="dataList.length <= 0" description=""></el-empty>
    </div>
</template>
<script>
export default {
  name: 'Practice',
  props: {
    courseId: { //课程ID
      type: String,
      required:true
    }
  },
  data() {
    return {
      dati:require("../../../images/course/dati@2x.png"),
      chengji:require("../../../images/course/chengji@2x.png"),
      cuoti:require("../../../images/course/cuoti@2x.png"),
      shouc:require("../../../images/course/shouc@2x.png"),

      total: 0,
      limit:9,
      page:1,
      dataList: [],
    }
  },
  created() {
    this.getInfo();
  },
  mounted() {
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.getInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getInfo();
    },
    getInfo(){ //获取签到数据
      let param = {
        limit:this.limit,
        page:this.page,
        teacherOpenCourseId:this.courseId,
        teacherOpenCourseQuestionSettingType: 'CHAPTER_EXERCISE', // 章节练习
      }
      this.$post("/api/resourcesQuestionSnapshot/getQuestionTestSimpleInfo.do",param).then((ret) =>{
        if(ret.code == 0){
          this.total = Number(ret.count);
          this.dataList = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    ErrorSet(item){ //错题集
      this.$router.push({name:'ErrorSet',query:{id:item.teacherOpenCourseQuestionSettingId,courseId:this.courseId}});
    },
    Exercises(item){ //开始答题
      this.$router.push({name:'Exercises',query:{type:1,id:item.teacherOpenCourseQuestionSettingId,courseId:this.courseId,chapterId:item.teacherOpenCourseMergeCourseInfoId}});
    },
    achievement(item){ //查看成绩
      this.$router.push({name:'ExercisesDetails',query:{type:2,id:item.teacherOpenCourseQuestionSettingId,courseId:this.courseId,chapterId:item.teacherOpenCourseMergeCourseInfoId}});
    },
    favorites(item){ //我的收藏(课程)
      this.$router.push({name:'CourseFavorites',query:{type:2,id:item.teacherOpenCourseQuestionSettingId,courseId:this.courseId}});
    }
  }
};
</script>
<style  lang="less">
  .course_sut_Practice{
    ul{
      list-style-type:none;
      margin: 0;
      padding: 0;
    }
    li{
      float: left;
      width: calc(33.2% - 66px);
      margin: 0 20px 20px 0;
      min-height: 200px;
      border: 1px solid #E1E1E1;
      background-image: url("../../../images/course/num_bg@2x.png");
      background-size: 50px;
      background-repeat:no-repeat;
      position: relative;
      padding: 20px 20px 0;
      font-size: 14px;
      .num_practice{
        position: absolute;top: 10px;left: 10px;color: #2789E2;
      }
    }
    .title_practice{
      margin: 0;
      margin-left: 15px;float: left;
      width: calc(100% - 155px);
    }
    .number_practice{
      margin: 0;
      float: right;
      width: 140px;
      text-align: right;
    }
    .grade_Practice{
      display: flex;
      justify-content:center;
      align-items:center;
      width: 80px;height: 80px;margin: 0 auto;
      font-size: 22px;
      color: #F83131;
      background-color: #FFF6F6;
      border-radius: 50%;
      span{
        font-size: 14px;
        margin-left: 2px;
      }
    }
    .practice_img{
      width: 30px;
      height: 30px;
    }

    @media screen and (max-width:1536px){
      li{
        width: calc(33% - 66px);
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/course/components/Practice.vue